module.exports = __webpack_public_path__ + "static/media/wallet.e52a562b.png";